<div>
  <div class="title">
    <h2 class="primary" *ngIf="!isBulk"><span i18n="@@Move Project">Move Project</span>&nbsp;"{{project.name}}"</h2>
    <!--
      Count rather than a list of names in the heading: five titles do not
      fit on one line and the heading is what the operator checks before
      committing. The names are listed in full below.

      numberFormat, not a bare interpolation -- five locales declare a
      non-Western digit table and a raw {{ }} renders Western digits in
      all of them. See AGENTS.md.
    -->
    <h2 class="primary" *ngIf="isBulk"><span i18n="@@Move Projects">Move Projects</span>&nbsp;({{projects.length | numberFormat}})</h2>
  </div>
  <div>
    <form [formGroup]="changeForm" (change)="formChanged()">
      <app-folder-path *ngIf="currentFolder && !isBulk" [path]="currentFolder"><ng-container i18n="@@Current folder">Current folder</ng-container></app-folder-path>
      <!--
        A multiple selection has no single "current folder" to show -- the
        usual reason to build one is that the Projects are spread across
        several. The set itself is shown instead, because this is the last
        point at which the operator can check it against what they meant
        to select, and the move that follows is N separate writes that
        cannot be undone as a group.
      -->
      <div class="moveProjectList" *ngIf="isBulk">
        <span class="moveProjectListItem" *ngFor="let p of projects">{{p.name}}</span>
      </div>
      <!--
        `rootLabel` makes the top level selectable. Without it an
        organization with no folders saw an empty box and a button that
        could never enable, and a Project inside a folder could not be
        moved back to the top level at all.
      -->
      <app-tree-selector [rawData]="{'': projectFolders.getJSON()}"
                         rootLabel="My Projects"
                         i18n-rootLabel="@@My Projects"
                         emptyMessage="You do not have any folders yet. Projects live at the top level until you create one."
                         i18n-emptyMessage="@@treeSelectorNoFolders"
                         [currentPath]="currentFolder"
                         (nodeSelected)="handleSelection($event)"></app-tree-selector>
      <div class="newFolderNotSelected" *ngIf="!changeValid && !isBulk" i18n="@@Please select a folder to move the project to">Please select a folder to move the project to</div>
      <div class="newFolderNotSelected" *ngIf="!changeValid && isBulk" i18n="@@Please select a folder to move the projects to">Please select a folder to move the projects to</div>
      <div class="folderBreadCrumbs" *ngIf="changeValid">
        <span *ngIf="!isBulk" i18n="@@Move Project To">Move Project To</span>
        <span *ngIf="isBulk" i18n="@@Move Projects To">Move Projects To</span>
        <button [disabled]="Util.getParentItem(currentFolder, '/') === '/'" mat-flat-button matBadgeColor="primary" (click)="handleSelection('/')" color="primary" style="color: black; background: inherit; padding-right: 0px;" i18n="@@My Projects">My Projects</button>
        <ng-container *ngFor="let folder of Util.getCumulativeStrings(newFolder, '/')">
          <ng-container *ngIf="folder !== '/'">
            <mat-icon style="margin-top: 9px;">chevron_right</mat-icon>
            <button mat-flat-button color="primary" (click)="handleSelection(folder)" color="primary"  style="color: black; background: inherit; padding-right: 0px; padding-left: 0px;">{{Util.getLastItem(folder, '/')}}</button>
          </ng-container>
        </ng-container>
      </div>
      <!--
        Failures are shown HERE and the dialog stays open on them.

        'errorMessage' has been set on every refusal since this dialog was
        written and was rendered nowhere, so a refused move looked exactly
        like a move that had not been attempted yet: the dialog sat there,
        the Project had not moved, and nothing said why. A partial failure
        across a selection makes that worse, because some of the set moved
        and the grid behind the dialog looks plausible either way.
      -->
      <div class="move-project-error" *ngIf="errorMessage">
        <mat-icon>error_outline</mat-icon><span>{{errorMessage}}</span>
      </div>
      <div class="btn-sec">
        <button mat-raised-button type="button" class="Discard-btn" mat-dialog-close="" i18n="dialog dismissal|Button that closes a dialog and discards any unsaved edits. It never removes or destroys existing data - the Delete button does that. Must translate to a word meaning 'abandon this action', not 'erase'.@@Cancel">Cancel</button>
        <!-- Destination NAME, not the raw path: this used to read "Move to /". -->
        <button mat-raised-button type="submit" color="primary" class="Update-btn" [disabled]="!changeValid || moving" [title]="newFolderLabel" (click)="onChange()"><span *ngIf="!isBulk" i18n="@@Move to">Move to</span><span *ngIf="isBulk" i18n="@@Move Projects To">Move Projects To</span><span>&nbsp;</span>"{{newFolderLabel}}"</button>
      </div>
    </form>
  </div>
</div>
